module.exports = __webpack_public_path__ + "static/media/objective.f2f2fbdb.svg";